import { Link } from 'react-router-dom';

const seoArticles = [
  {
    path: '/blog/budget-spreadsheet',
    title: 'Best Budget Product Spreadsheet Guide',
    description: 'Maximize every dollar with our budget-focused comparison framework that helps cost-conscious shoppers find the best value without sacrificing quality.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20calculator%20receipts%20notebook%20and%20colorful%20spreadsheet%20charts%20printed%20on%20paper%20bright%20morning%20sunlight%20through%20sheer%20curtains%20budgeting%20aesthetic%20warm%20neutral%20tones&width=800&height=500&seq=article-card-v2-budget&orientation=landscape',
    date: 'Jan 15, 2026',
    readTime: '4 min read',
  },
  {
    path: '/blog/sneakers-vs-boots',
    title: 'Sneakers vs Boots: Footwear Spreadsheet Showdown',
    description: 'Side-by-side comparison of sneakers and boots using structured data analysis to help you pick the right footwear for your lifestyle and budget.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20white%20sneakers%20and%20rugged%20leather%20boots%20paired%20on%20weathered%20wooden%20floor%20dramatic%20side%20lighting%20industrial%20loft%20setting%20contrasting%20textures&width=800&height=500&seq=article-card-v2-sneakers-boots&orientation=landscape',
    date: 'Jan 20, 2026',
    readTime: '5 min read',
  },
  {
    path: '/blog/compare-online',
    title: 'How to Compare Products Online Effectively',
    description: 'Master the art of systematic product comparison using structured spreadsheets that eliminate tab overload and make the best choice obvious.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20using%20laptop%20and%20tablet%20comparing%20products%20on%20multiple%20screens%20bright%20modern%20co-working%20space%20natural%20daylight%20streaming%20through%20large%20windows&width=800&height=500&seq=article-card-v2-compare&orientation=landscape',
    date: 'Jan 28, 2026',
    readTime: '6 min read',
  },
  {
    path: '/blog/top-100-list',
    title: 'Top 100 Product Spreadsheet List for Smart Shoppers',
    description: 'Our curated list of the top 100 products smart shoppers are comparing right now, spanning every category from sneakers to lifestyle accessories.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Impressive%20grid%20display%20of%20diverse%20fashion%20and%20lifestyle%20products%20arranged%20gallery%20style%20in%20modern%20minimalist%20interior%20bright%20gallery%20lighting&width=800&height=500&seq=article-card-v2-top100&orientation=landscape',
    date: 'Feb 3, 2026',
    readTime: '8 min read',
  },
  {
    path: '/blog/fashion-database',
    title: 'Fashion Spreadsheet Database: Style Companion',
    description: 'Build your personal fashion database to track your wardrobe, plan purchases, and ensure every new piece complements your existing style.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20fashion%20design%20studio%20with%20clothing%20racks%20fabric%20swatches%20color%20palette%20cards%20and%20large%20mood%20board%20bright%20airy%20creative%20atmosphere&width=800&height=500&seq=article-card-v2-fashion&orientation=landscape',
    date: 'Feb 10, 2026',
    readTime: '5 min read',
  },
  {
    path: '/blog/vs-traditional',
    title: 'PandabuySpreadsheet vs Traditional Shopping',
    description: 'Head-to-head comparison showing data-driven shopping consistently beats traditional browsing across satisfaction, savings, and time efficiency.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20desk%20scene%20chaotic%20messy%20left%20versus%20clean%20organized%20right%20dramatic%20before%20and%20after%20contrast%20conceptual%20photography%20bright%20studio%20lighting&width=800&height=500&seq=article-card-v2-vs&orientation=landscape',
    date: 'Feb 18, 2026',
    readTime: '7 min read',
  },
  {
    path: '/blog/value-sneakers-2026',
    title: 'Best Value Sneakers Comparison 2026: Data-Driven Picks',
    description: 'Dozens of sneaker models analyzed across price, quality, comfort, and style versatility — discover which ones truly deliver the best value this year.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20fashion%20sneakers%20on%20floating%20glass%20shelves%20against%20gradient%20sunset-colored%20wall%20creative%20retail%20display%20bright%20energetic%20lighting&width=800&height=500&seq=article-card-v2-sneakers-val&orientation=landscape',
    date: 'Feb 25, 2026',
    readTime: '6 min read',
  },
  {
    path: '/blog/research-system',
    title: 'Product Research System: Shop Like a Pro Buyer',
    description: 'Adapt enterprise procurement techniques for your personal shopping with a four-phase research workflow that guarantees confident decisions.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20analyzing%20data%20on%20large%20monitor%20with%20colorful%20charts%20and%20tables%20modern%20office%20exposed%20brick%20wall%20warm%20desk%20lamp%20analytical%20atmosphere&width=800&height=500&seq=article-card-v2-research&orientation=landscape',
    date: 'Mar 4, 2026',
    readTime: '5 min read',
  },
  {
    path: '/blog/buy-smarter',
    title: 'Buy Smarter Online: Complete PandabuySpreadsheet Guide',
    description: 'The ultimate guide to transforming your shopping approach with structured data — from preparation and execution to reflection and continuous improvement.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Happy%20person%20unboxing%20stylish%20products%20at%20home%20on%20cozy%20sofa%20warm%20afternoon%20sunlight%20genuinely%20joyful%20lifestyle%20editorial%20natural%20warm%20tones&width=800&height=500&seq=article-card-v2-buy-smart&orientation=landscape',
    date: 'Mar 12, 2026',
    readTime: '7 min read',
  },
];

export default function ArticleGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-12 gap-6">
          <div>
            <p className="text-foreground-400 text-sm font-medium uppercase tracking-wider mb-2">SEO Articles &amp; Guides</p>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
              Shop Smarter with Our Product Research Guides
            </h2>
          </div>
          <p className="text-foreground-600 text-sm max-w-md leading-relaxed">
            Expert guides, data-driven comparisons, and actionable tips to help you make better buying decisions using the pandabuyspreadsheet methodology.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group block cursor-pointer"
            >
              <article className="bg-background-50 rounded-lg overflow-hidden transition-all duration-300 group-hover:scale-[1.02] h-full flex flex-col">
                <div className="relative h-44 md:h-48 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    title={`${article.title} - PandabuySpreadsheet`}
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs text-foreground-400">{article.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-accent-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-xs leading-relaxed flex-1">
                    {article.description}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-accent-600 text-xs font-medium">
                    <span>Read Article</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}